import { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Typography from "../../../../components/Typography";
import EnrollmentValorationComponent from "../../../../components/EnrollmentValoration";
import Button from "../../../../components/Button";
import { InputContainer } from "./styles";
import useIsMobile from "../../../../hooks/deviceChecker";
import { useLayout } from "../../../../provider/LayoutProvider";
import { EnrollmentValoration } from "../../../../types/enrollment.dto";
import services from "../../../../services";
import { useDispatch, useSelector } from "react-redux";
import { getAllEnrollments } from "../../../../store/actions/enrollment";
import { getOneCourse } from "../../../../store/actions/course";
import { Action, Dispatch } from "redux";

const Component = () => {
  const params = useParams();
  const isMobile = useIsMobile();
  const dispatch = useDispatch<Dispatch<Action>>();
  const { layout, setLayout, applyedFilters } = useLayout();
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const enrollment = useSelector((state: any) => state.courseStore.getOne.data);
  const navigate = useNavigate();

  const getEnrollments = ({ page }) => {
    dispatch(
      getAllEnrollments({
        pagination: {
          page,
          limit: 10,
        },
        filters: applyedFilters,
      })
    );
  };

  useEffect(() => {
    setLayout({
      ...layout,
      showFilters: false,
      showSearchBar: false,
      showBackButton: true,
      showSubHeader: !isMobile,
    });
  }, [isMobile]);

  const enrollmentValoration = (formValue: EnrollmentValoration): void => {
    setFormSubmitted(true);
    services.enrollment
      .enrollmentValoration({
        text: formValue.text,
        rating: formValue.rating,
        enrollment_id: enrollment.labEnrollment[0].id,
      })
      .then(() => {
        navigate(`/dashboard/mis-cursos/${enrollment.id}/finished`);
        setFormSubmitted(false);
        getEnrollments({ page: 1 });
      })
      .catch((error) => {
        // Manejar errores aquí
        console.error("Error submitting enrollment valoration:", error);
        setFormSubmitted(false);
      });
  };

  useEffect(() => {
    if (params.idCourse) {
      dispatch(getOneCourse({ idCourse: Number(params.idCourse) }));
    }
  }, [params]);

  return (
    <div style={{ padding: "10px" }}>
      <Typography as="h2" style={{ marginBottom: 5 }}>
        Valoración
      </Typography>
      <Typography as="p" size="xs" style={{ marginBottom: 5 }}>
        ¡Compartinos tu experiencia!
      </Typography>
      <Formik
        initialValues={{
          rating: 5,
          text: "",
        }}
        onSubmit={(values) => {
          enrollmentValoration(values);
        }}
        validateOnChange={formSubmitted}
        validateOnBlur={false}
        enableReinitialize
      >
        {({ values, handleChange }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <InputContainer>
              <label htmlFor="rating" style={{ marginBottom: 10 }}>
                En general, ¿Cuál es el grado de satisfacción con el curso que
                hiciste?
              </label>
              <Field
                name="rating"
                render={({ field }) => (
                  <EnrollmentValorationComponent
                    {...field}
                    rating={values.rating}
                    onClick={(value) =>
                      handleChange({ target: { name: "rating", value } })
                    }
                  />
                )}
              />
            </InputContainer>
            <InputContainer>
              <label htmlFor="text" style={{ marginBottom: 10 }}>
                ¿Tenes algún comentario adicional sobre el curso o la
                plataforma?
              </label>
              <Field
                name="text"
                style={{ width: "100%", minHeight: 100 }}
                as="textarea"
                maxLength={240}
              />
            </InputContainer>
            <Button
              style={{ width: "40%" }}
              type="submit"
              options={{
                type: "filled",
                size: "md",
                skin: "primary",
              }}
              disabled={formSubmitted}
              loading={formSubmitted}
            >
              Valorar
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Component;
